'use strict';

import { loadScript } from "@paypal/paypal-js";

let { paypal_client_id, donation_test_mode } = drupalSettings;


const PAYPAL_SUCCESS_URL = `${window.location.protocol}//${window.location.host}/donate`;
const PAYPAL_CANCEL_URL = `${window.location.protocol}//${window.location.host}/donate`;

const PAYPAL_CREATE_ORDER_API_URL = "/api/rspca_donation/paypal/create_order";
const PAYPAL_CREATE_PLAN_API_URL = "/api/rspca_donation/paypal/create_plan";

let paypal;

const attachPaypalButton = async (element, data) => {
  if (data.donation_details.frequency == 'once') {
    paypal = await loadScript({ clientId: paypal_client_id, currency: "AUD", "disable-funding": "credit,card", "vault": true });
    paypal.Buttons({
      async createOrder() {
        try {
          let request = {
            "email": data.your_details.email,
            "success_url": PAYPAL_SUCCESS_URL,
            "cancel_url": PAYPAL_CANCEL_URL,
            "amount": data.donation_details.amount,
            "meta_data": { ...data.your_details, ...data.donation_details },
            "mode": data.donation_details.frequency == 'once' ? 'payment' : 'subscription'
          }
          const response = await fetch(PAYPAL_CREATE_ORDER_API_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(request),
          });

          const orderData = await response.json();

          if (orderData.data.order_id) {
            return orderData.data.order_id;
          } else {
            const errorDetail = orderData?.details?.[0];
            const errorMessage = errorDetail
              ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
              : JSON.stringify(orderData);

            throw new Error(errorMessage);
          }
        } catch (error) {
          alert(`Could not initiate PayPal Checkout. Please try again later.`);
          console.log(`Could not initiate PayPal Checkout...<br><br>${error}`);
        }
      },
      async onApprove(data, actions) {
        try {
          const response = await fetch(`/api/rspca_donation/paypal/orders/${data.orderID}/capture`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });

          const orderData = await response.json();
          // Three cases to handle:
          //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
          //   (2) Other non-recoverable errors -> Show a failure message
          //   (3) Successful transaction -> Show confirmation or thank you message

          const errorDetail = orderData.data?.details?.[0];
          
          if (donation_test_mode) {
            console.log("Errors",errorDetail);
          }

          if (errorDetail?.issue === "INSTRUMENT_DECLINED") {
            // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
            // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
            return actions.restart();
          } else if (errorDetail) {
            // (2) Other non-recoverable errors -> Show a failure message
            throw new Error(`${errorDetail.description} (${orderData.data.debug_id})`);
          } else if (!orderData.data.purchase_units) {
            throw new Error(JSON.stringify(orderData.data));
          } else {
            // (3) Successful transaction -> Show confirmation or thank you message
            // Or go to another URL:  actions.redirect('thank_you.html');
            const transaction =
              orderData.data?.purchase_units?.[0]?.payments?.captures?.[0] ||
              orderData.data?.purchase_units?.[0]?.payments?.authorizations?.[0];
            $(".webform-submission-donate-form").html(`
                <div class='pt-medium pb-medium'>
                  <div class='text-4xl font-bold leading-none'>Donation Successfully Processed!</div>
                  <div class='mt-medium'>Thank you for your donation</div>
                </div>
              `);

            if (donation_test_mode) {
              console.log(
                "Capture result",
                orderData.data,
                JSON.stringify(orderData.data, null, 2),
              );
            }
          }
        } catch (error) {
          console.error(error);
          alert(
            `Sorry, your transaction could not be processed...<br><br>${error}`,
          );
        }
      },

    }).render(element);
  } else {
    paypal = await loadScript({ clientId: paypal_client_id, currency: "AUD", "disable-funding": "credit,card", "vault": true, intent: 'subscription' });
    paypal.Buttons({
      async createSubscription(record, actions) {
        try {
          let request = {
            "email": data.your_details.email,
            "success_url": PAYPAL_SUCCESS_URL,
            "cancel_url": PAYPAL_CANCEL_URL,
            "amount": data.donation_details.amount,
           "meta_data": { ...data.your_details, ...data.donation_details },
            "mode": data.donation_details.frequency == 'once' ? 'payment' : 'subscription'
          }
          const response = await fetch(PAYPAL_CREATE_PLAN_API_URL, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            // use the "body" param to optionally pass additional order information
            // like product ids and quantities
            body: JSON.stringify(request),
          });

          const planData = await response.json();

          if (planData.data.subscription_id) {
            return actions.subscription.create({ plan_id: planData.data.subscription_id });
          } else {
            const errorDetail = planData?.details?.[0];
            const errorMessage = errorDetail
              ? `${errorDetail.issue} ${errorDetail.description} (${planData.debug_id})`
              : JSON.stringify(planData);

            throw new Error(errorMessage);
          }
        } catch (error) {
          alert('An error occurred during the subscription process. Please try again.');
          console.log(`Could not initiate PayPal Checkout...<br><br>${error}`);
        }
      },
      async onApprove(data, actions) {
        try {          
          const response = await fetch(`/api/rspca_donation/paypal/subscription/${data.subscriptionID}/capture`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
          });

          const orderData = await response.json();
          
          // (3) Successful transaction -> Show confirmation or thank you message
          // Or go to another URL:  actions.redirect('thank_you.html');
          const transaction =
            orderData.data?.purchase_units?.[0]?.payments?.captures?.[0] ||
            orderData.data?.purchase_units?.[0]?.payments?.authorizations?.[0];
          $(".webform-submission-donate-form").html(`
              <div class='pt-medium pb-medium'>
                <div class='text-4xl font-bold leading-none'>Donation Successfully Processed!</div>
                <div class='mt-medium'>Thank you for your donation</div>
              </div>
            `);

          if (donation_test_mode) {
            console.log(
              "Capture result",
              orderData.data,
              JSON.stringify(orderData.data, null, 2),
            );
          }
          
        } catch (error) {
          console.error(error);
          alert(
            `Sorry, your transaction could not be processed...<br><br>${error}`,
          );
        }
      },
      onCancel(data) {

      },
      onError: function(err) {
        console.error('An error occurred during the subscription process:', err);
        alert('An error occurred during the subscription process. Please try again.');
    }
    }).render(element);
  }
}

export {
  attachPaypalButton
}